import type {
  GetConfigResponse,
  GetMeResponse,
  GetMeStateResponses,
  GetMeWalletResponse,
} from '@/client'
import {
  getConfigQueryKey,
  getMeQueryKey,
  getMeStateQueryKey,
  getMeWalletQueryKey,
} from '@/client/@tanstack/react-query.gen'
import { readCache } from '@/store/action'

export const getConfig = () => {
  const data = readCache(getConfigQueryKey()) as GetConfigResponse
  return data
}

export const getUserInfo = () => {
  const data = readCache(getMeQueryKey()) as GetMeResponse
  return data
}

export const getUserState = () => {
  const data = readCache(getMeStateQueryKey()) as GetMeStateResponses
  return data
}

export const getWallet = () => {
  const data = readCache(getMeWalletQueryKey()) as GetMeWalletResponse
  return data
}

// export const useUserInfo = (options?: Partial<UseQueryOptions>) => {
//   const userData = $api.useQuery('get', '/me', {}, {
//     enabled: true,
//     queryHash: 'UserInfo',
//   })
//   return userData
// }

// export const useUserInfo = (options?: Partial<UseQueryOptions>) => {
//   let opts = {
//     queryKey: [queryKey],
//     queryFn: async (): Promise<UserData> => {
//       const [resUser, resStore] = await Promise.all([
//         client.GET('/api/users'),
//         client.GET('/api/store')
//       ]);

//       return {
//         userInfo: (resUser?.data?.user || {})as User,
//         userShop: (resStore?.data?.userStore || {}) as UserStore
//       }
//     }
//   }
//   Object.assign(opts, options);

//   return useQuery(opts)
// }
